import { Link, useNavigate } from "react-router-dom";
import { useSelector} from "react-redux";
import { Policy } from "../objects/policy";
import { useContext } from "react";
import SettingsContext from "../store/settingscontext";

function Header(){    
    const settings = useContext<any>(SettingsContext);
    const policy = useSelector((state: any)=> state.policyReducer) as Policy;
    let navigate = useNavigate();
    
    function renderPhoneLink(){
        if(process.env.REACT_APP_CLIENT === "ALSET"){
            return <>
            Call <Link to="tel:+14756193790">475-619-3790</Link>
            </>;
        }

        return <>
            Call <Link to="tel:+18882700025">1-888-270-0025</Link>
            </>;
    }
    return (
        <header className="w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw]">
            <div className="logo float-left">
                <span className="hover:cursor-pointer" onClick={(e)=>{
                    let path = "/" + window.location.search;
                    navigate(path, {state: {data: policy, hasData: true}})
                }}>
                    <img src={settings?.Logo} className="w-64" />
                </span>
            </div>

            <div className="float-right">
                <span className="font-bold">
                    We're Here to Help
                </span>
                <br/>
                <span className="">
                    {renderPhoneLink()}
                </span>
            </div>
        </header>
    );
}

export default Header;